import { render } from "./rejectCRMWhatsappConversationDialog.vue?vue&type=template&id=5f6194b1&scoped=true"
import script from "./rejectCRMWhatsappConversationDialog.vue?vue&type=script&lang=js"
export * from "./rejectCRMWhatsappConversationDialog.vue?vue&type=script&lang=js"

import "./rejectCRMWhatsappConversationDialog.vue?vue&type=style&index=0&id=5f6194b1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f6194b1"]])

export default __exports__